import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import HtmlPage from 'views/htmlPage/HtmlPage';
import SplitPane from 'views/splitPane/SplitPane';
import ProjectsForm from 'views/projectsForm/ProjectsForm';
import ProjectsList from 'views/projectsList/ProjectsList';
import Button from 'views/button/Button';


import './projects.scss';
import URLService from "../../../service/URLService";

import projectsStore from 'storeState/projects';
import tenantsStore from 'storeState/tenants';
import authStore from 'storeState/auth';
import _ from 'lodash';

class Projects extends Component {

    constructor(props) {
        super(props);
    }

    onProjectSelect = (project_id) => {
        URLService.setQueryParameter("project_id", project_id);
        this.setState({})
    }

    handleNewClick = (project_id) => {
        URLService.removeQueryParameter("project_id");
        this.setState({})
    }

    render() {
        return (
            <HtmlPage className="screen-projects" >
                <div className="content-projects">
                    <SplitPane percentage={true} id="projects" store={true}>
                        <div>
                            <div className="projects-buttonbar">
                                <Button onClick={this.handleNewClick}>
                                    <FormattedMessage id="projects.create" defaultMessage="Create a new project"  />
                                </Button>
                            </div>
                            <ProjectsList
                                onProjectSelect={this.onProjectSelect}
                                tenant_id={this.props.currentTenantId}
                            />
                        </div>
                        <div>
                            <ProjectsForm
                                project_id={URLService.getQueryParameterAsString("project_id")}
                                tenant_id={this.props.currentTenantId}
                            />
                        </div>
                    </SplitPane>
                </div>
            </HtmlPage>
        );
    }
}

export default connect((state, props) => {
    return {
        projects: projectsStore.selectors.projectsList(state),
        loginData: authStore.selectors.loginData(state),
        currentTenantId: authStore.selectors.currentTenantId(state)
    }
},(dispatch, props) => {
    return {
        actions: bindActionCreators(Object.assign({}, {...tenantsStore.actions, ...projectsStore.actions}), dispatch)
    }
})(Projects)


// WEBPACK FOOTER //
// ./src/components/screens/projects/Projects.js